import { AxiosRequestConfig } from "axios";

import { ApiResponse, post } from "@api/httpClient";

interface ApplicantFaceLivenessStartParams {
  applicantExamId: number;
  options?: AxiosRequestConfig;
}

export async function applicantFaceLivenessStart({
  applicantExamId,
  options,
}: ApplicantFaceLivenessStartParams) {
  const { data } = await post<ApiResponse<{ sessionId: string }>>(
    `/api/applicants/exams/${applicantExamId}/webcam/session/start`,
    options,
  );

  return data;
}

export async function applicantFaceLivenessFinish({
  applicantExamId,
  sessionId,
  options,
}: {
  applicantExamId: number;
  sessionId: string;
  options?: AxiosRequestConfig;
}) {
  const { data } = await post<
    ApiResponse<{
      isLive: boolean; // determines if the check succeeded
      sessionId: string;
      status: "SUCCEEDED";
    }>
  >(
    `/api/applicants/exams/${applicantExamId}/webcam/session/${sessionId}/finish`,
    options,
  );

  return data;
}
